import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'styled-components';
import {
  StyledOuter,
  StyledWrapper,
  StyledDropdownContainer,
  StyledButtonDropdown,
  StyledDropdownSpan,
  StyledDropdownCaretArea,
  StyledDropdownCaret,
  StyledOptionsOuter,
  StyledOptionsList,
  StyledOption,
  StyledDropdownLabel,
  StyledDropdownValue,
  StyledTextInput,
  StyledNoResultsMessage,
  StyledMultiSelectTag,
  StyledPrimaryLabel,
  StyledSecondaryLabel,
  StyledClearButton,
  StyledOptionDivWrapper
} from './Typeahead.styles'

import { Icon } from '../../shared/tr-icons'
import { generateUUID } from '../../shared/utilities'

// import getElementBounds from '../../shared/utilities/dom/getElementBounds'
import Breakout from '../breakout/Breakout'

const pID = generateUUID()

const CELL_HEIGHT = 60
const OPTIONS_MAX_HEIGHT = 7 * CELL_HEIGHT
const CLOSED = 'closed'
const OPENED = 'opened'

class ComponentTypeahead extends Component {
  constructor(props) {
    super(props)

    let multiSelectValues = []

    if (props.selectedValues && props.selectedValues.length > 0) {
      multiSelectValues = props.selectedValues.map((item) => item.value)
    }
    let multiHeaderOptionsCount = 0

    if (props.headers && props.headers.length > 0) {
      props.headers.map((header) => {
        ++multiHeaderOptionsCount
        header.options.map((option) => {
          ++multiHeaderOptionsCount
        })
      })
    }

    this.state = {
      // is used to hide the dropdown control in multi select mode when max number of options has been selected
      controlEnabled: true,
      listVisible: false,
      selectedValue: props.selectedValue || '',
      focusOption: 0,
      inputVisible: false,
      inputValue: '',
      options: props.options, // provided by the application/endpoint
      filteredOptions: props.options, // dynamic, depends on user input
      multiSelectValues,
      multiHeaderOptionsCount,
      status: CLOSED
    }

    this.isShowingNoSearchResults = false
    this.wrapperEl = null
    this.dropdownEl = null
    this.ddInputEl = null
    this.translateY = 0
    this.labelText = ''
  }

  componentWillReceiveProps(newProps) {
    let multiSelectValues = []
    let selectedValue = ''

    if (newProps.selectedValues && newProps.selectedValues.length > 0) {
      multiSelectValues = newProps.selectedValues.map((item) => item.value)
    }

    if (newProps.name && newProps.name === 'Dropdown' && newProps.selectedValue && newProps.selectedValue.length > 0) {
      selectedValue = newProps.selectedValue
    }

    if (newProps.name && newProps.name === 'select' && newProps.selectedValue && newProps.selectedValue.length > 0) {
      selectedValue = newProps.selectedValue
    }

    const others = {}

    if (multiSelectValues && this.props.maxNumOfSelections && multiSelectValues.length < this.props.maxNumOfSelections) {
      others.controlEnabled = true
    }

    this.setState({
      selectedValue,
      multiSelectValues,
      ...others
    })
  }

  componentDidMount() {
    if (this.props.endpoint) {
      this.fetchDataViaAJAX()
    }
  }

  componentDidUpdate() {
    requestAnimationFrame(() => { // We need to wait a tick before refs are avaiable
      const { listVisible, filteredOptions } = this.state

      if (this.props.typeAheadEnabled && this.state.inputVisible && this.ddInputEl) {
        this.ddInputEl.focus()
      }
      if (!listVisible && this.ddInputEl) {
        this.ddInputEl.blur()
      }

      const optionsEl = this.dropdownEl.querySelector('ul')

      // Calculating dropdown height
      let totalHeight = CELL_HEIGHT

      if (optionsEl) {
        totalHeight += optionsEl.offsetHeight

        // Needs scrolling?
        const itemsHeight = Array.from(optionsEl.children).reduce((acc, child) => acc + child.offsetHeight, 0)

        optionsEl.style.overflow = (itemsHeight > OPTIONS_MAX_HEIGHT) ? 'auto' : 'hidden'
        optionsEl.style.overflowX = 'hidden'
      }

      // Add height for "No search results"
      if (filteredOptions && filteredOptions.length === 0) {
        totalHeight += CELL_HEIGHT
      }

      // Apply height and style for open/closed
      this.dropdownEl.style.height = `${totalHeight}px`
      this.dropdownEl.style.boxShadow = listVisible ? '5px 5px 4px rgba(0,0,0, 0.2)' : '1px 1px 1px rgba(0,0,0,0)'

      /*
      // Breakout positioning
      // This moves the dropdown just above the fold, so the user wouldn't have to scroll.
      // Neat in theory, but a bit unwieldy with typeAheadEnabled=true, as the box changes height during search.
      if( this.state.status !== CLOSED ){
        // Option A. Relative to page
        // const bounds = getElementBounds( this.dropdownEl, true )
        // const availHeight = document.documentElement.scrollHeight

        // Option B. Relative to viewport
        const bounds = getElementBounds(this.dropdownEl)
        const availHeight = window.innerHeight //* /

        const overlap = availHeight - (bounds.y - this.translateY + totalHeight)

        if (overlap < 0) { // Outside viewport
          const offset = overlap - 15 // Adding 15px margin, so doesn't sit right on the edge
          this.translateY = offset
          this.dropdownEl.style.transform = `translate3d(0px,${offset}px,0px)`
        } else {
          this.dropdownEl.style.transform = `translate3d(0px,0px,0px)`
          this.translateY = 0
        }
      }
      // */
    }, 0)
  }

  onRefWrapper = el => {
    this.wrapperEl = el
  }

  onRefDropdown = el => {
    this.dropdownEl = el
  }

  fetchDataViaAJAX = () => {
    let options = []
    const filteredOptions = []
    const that = this

    const ajax = new XMLHttpRequest()

    ajax.open('GET', this.props.endpoint, true)
    ajax.send()
    ajax.onreadystatechange = function() {
      if (ajax.readyState === 4 && ajax.status === 200) {
        if (ajax.responseText) {
          options = JSON.parse(ajax.responseText)

          options.map((option, index) => {
            filteredOptions.push(option)
          })

          that.setState(
            {
              options,
              filteredOptions
            }
          )
        } else {
          console.warn('ajax: no options returned from ' + this.props.endpoint)
        }
      }
    }
  }

  handleDropdownClick = (e) => {
    e.preventDefault()
    e.stopPropagation()

    if (!this.state.controlEnabled) { return }

    this.toggleListVisible(true)

    this.setState({
      inputVisible: true
    })
  }

  handleKeyDown = (e) => {
    if (e.target && e.target.name && e.target.name === 'typeaheadInput') {
      return
    }

    const { listVisible, focusOption } = this.state
    const isUpdateStateRequired = true

    this.toggleListVisible(!listVisible)

    e.keyCode === 27 // Esc
      ? this.hideDropdown()
      : this.setElementToFocus(focusOption, isUpdateStateRequired)
    e.preventDefault()
    e.stopPropagation()
  }

  handleOptionClick = (e) => {
    e.stopPropagation()
    e.preventDefault()

    if (this.props.multiheaderEnabled && e.target.getAttribute('role') === 'header') {
      document.removeEventListener('click', this.hideDropdown)
      return
    }

    const selectedValue = e.target.getAttribute('data-value')

    if(!selectedValue) return

    const focusOption = parseInt(e.target.getAttribute('tabIndex'))
    
    this.setState({ selectedValue, focusOption })

    // Max number of options that could be selected by user
    const limit = this.props.maxNumOfSelections

    // adding newly selected value to the array of selected values (to be used if multiselect is enabled)
    if (this.props.multiSelectEnabled && this.state.multiSelectValues.indexOf(selectedValue) === -1 &&
        // allow selection if limit is not set or hasn't been reached yet
        (!limit || (limit && this.state.multiSelectValues.length < limit))) {
      this.setState({
        multiSelectValues: [...this.state.multiSelectValues, selectedValue],
        controlEnabled: this.state.multiSelectValues.length < limit - 1 // Once the limit is reached disable the dropdown
      })
    }

    if (this.props.onChange) {
      this.props.onChange(selectedValue, this.state.multiSelectValues)
    }

    this.hideDropdown()
    this.dropDownBtn.focus()

    if (this.props.typeAheadEnabled && this.state.options && this.state.options.length) {
      this.setState({
        inputValue: '', // clearing up the search field upon selection
        filteredOptions: [...this.state.options] // resetting filtered options so that all options are available during next selection
      })
    }
  }

  handleOptionKeyDown = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (e.target && e.target.name && e.target.name === 'typeaheadInput') {
      return
    }
    const lastIndex = this.props.multiheaderEnabled ? this.state.multiHeaderOptionsCount : this.state.options.length - 1
    const isUpdateStateRequired = true
    let { focusOption } = this.state

    switch (e.keyCode) {
      case 38: // up
      case 8: // backspace
        focusOption = !focusOption ? lastIndex : (focusOption - 1)
        break
      case 13: // Enter
      case 32: // Space
        // focusOption = focusOption TODO: follow-up what is this supposed to be doiing
        return this.handleOptionClick(e)
      case 9: // Tab
      case 40: // Down
        focusOption = lastIndex > focusOption ? (focusOption + 1) : 0
        break
      case 27: // Esc
        return this.hideDropdown()
    }
    this.setElementToFocus(focusOption, isUpdateStateRequired)
  }

  handleOptionMouseOver = (e) => {
    e.preventDefault()
    e.stopPropagation()

    const isUpdateStateRequired = false
    const currentTabIndex = e.target.tabIndex

    this.setElementToFocus(currentTabIndex, isUpdateStateRequired)
  }

  hideDropdown = (e) => {
    if (e && e.target && ((e.target.name && e.target.name === 'typeaheadInput') || e.target.id === 'noResultsMessage')) {
      return
    }

    // Clears search
    this.setState({ inputValue: '', userInput: '', filteredOptions: this.props.options })

    this.setState({ listVisible: false, inputVisible: false })
    document.removeEventListener('click', this.hideDropdown)
  }

  toggleListVisible = (isUpdateState) => {
    if (isUpdateState) {
      const { listVisible } = this.state
      const newState = { listVisible: !listVisible }

      if (!listVisible) newState.status = OPENED
      this.setState(newState)
    }

    document.addEventListener('click', this.hideDropdown)
  }

  // @TODO - Needs to be revised
  // Commented out for now as this is a minor issue and doesn't affect important functionality
  // Things to consider:
  // · Setting focus on mouseover interferes with search
  // · Keyboard nav via arrow keys didn't actually work
  setElementToFocus = (focusOption, isUpdateStateRequired) => {
    /*
    let elementToFocus = null

    if (this.props.multiheaderEnabled) {
      elementToFocus = document.querySelector(`#ui__dropdown_option_${focusOption}_${pID}`)
        ? document.querySelector(`#ui__dropdown_option_${focusOption}_${pID}`)
        : document.querySelector(`#ui__dropdown_header_${focusOption}_${pID}`)
    } else {
      elementToFocus = document.querySelector(`#ui__dropdown_option_${focusOption}_${pID}`)
    }

    if (elementToFocus) {
      elementToFocus.focus()
      if (isUpdateStateRequired) {
        this.setState({ focusOption })
      }
    }
    // */
  }

  onInputChange = (e) => {
    e.preventDefault()
    e.stopPropagation()

    const userInput = e.target.value
    let { filteredOptions } = this.state

    if (this.state.options && this.state.options.length) {
      // update array of options based on user input
      filteredOptions = this.state.options.filter((item) => {
        return item.label.toLocaleLowerCase().indexOf(userInput.toLocaleLowerCase()) > -1
      })
    }
    // making sure the list expands automatically when user starts typing (listVisible: true)
    this.setState({ filteredOptions, inputValue: userInput, listVisible: true })
  }

  // render the text input field (not applicable in dropdown mode)
  renderTypeaheadInput = () => {
    return (
      <StyledTextInput
        name='typeaheadInput'
        innerRef={comp => { this.ddInputEl = comp }}
        onChange={this.onInputChange}
        onClick={this.onInputChange}
        className={this.state.inputVisible ? 'show' : 'hide'}
        disabled={!this.state.controlEnabled}
        value={this.state.inputValue}
        listVisible={this.state.listVisible}
      />
    )
  }

  renderNoResultsMessage = () => {
    const isDisplayed = Boolean(this.ddInputEl && this.ddInputEl.value && this.state.inputVisible && !this.isShowingNoSearchResults)
    const noResults = this.props.noResultsFoundText ? this.props.noResultsFoundText : 'No results found.'

    this.isShowingNoSearchResults = isDisplayed
    
    return (isDisplayed
      ? <StyledNoResultsMessage id='noResultsMessage' onClick={(e) => { e.stopPropagation(); e.preventDefault() }} >{ noResults }</StyledNoResultsMessage>
      : null
    )
  }

  // a utility function to remove an element from array
  removeArrayElement = (array, element) => {
    return array.filter(e => e !== element)
  }

  // click handler for the close icon - removes the tag and updates state accordingly
  handleTagsCloseClick = (itemToRemove, event) => {
    let reducedValues = []

    reducedValues = this.removeArrayElement(this.state.multiSelectValues, itemToRemove)

    const {onRemove} = this.props

    this.setState({
      multiSelectValues: reducedValues,
      controlEnabled: true // once one of previously selected values is removed make the dropdown available again
    })

    if (onRemove) {
      onRemove(itemToRemove, reducedValues)
    }
  }

  // get a display label for a particular value
  getMultiSelectDisplayLabel = (selectedValue) => {
    const matchingOptions = this.state.options.filter(option => option.value === selectedValue)
    const label = (matchingOptions && matchingOptions.length) ? matchingOptions[0].label : ''

    return label
  }

  // Label displayed on the page could be different from value submitted with the form
  renderMultiSelectTags = () => {
    // iterate through array of selected values and render them
    const selectedTags = this.state.multiSelectValues.map((item) => {
      const { name } = this.props
      const displayLabel = this.getMultiSelectDisplayLabel(item)

      return (
        <StyledMultiSelectTag key={item}>
          <input type='hidden' name={name} value={item} id={name + '_' + item} />
          <label htmlFor={name}>{ displayLabel }</label>
          <StyledClearButton data-value={item} onClick={(e) => this.handleTagsCloseClick(item, e)}>
            <Icon type='clearOutline' grey={true} />
          </StyledClearButton>
        </StyledMultiSelectTag>
      )
    })

    return (
      <div>
        { selectedTags }
      </div>
    )
  }

  onCloseComplete = (e) => {
    if (e.target === e.currentTarget && e.propertyName === 'height') {
      this.setState({ status: CLOSED })
    }
  }

  /**
   *  The structure:
   *
   *   <StyledOuter>                      // Outermost container
   *       <StyledPrimaryLabel>           // [optional] labels
   *       ...tags...                     // [optional] tags
   *       <StyledWrapper>                // Wrapper, Breakout positioning
   *           <StyledDropdownContainer>  // Main thing, pops out, contains caret button and list/options elements
   *
   */
  render() {
    const { multiheaderEnabled, headers } = this.props
    const { controlEnabled, listVisible, selectedValue, inputVisible, status } = this.state
    const options = this.state.filteredOptions

    const useBreakout = window.innerWidth > this.props.theme.responsive.breakpoints.md
    const isBreakoutActive = useBreakout && status !== CLOSED

    const styledDropdownContainer = (
      <StyledDropdownContainer
        data-name='DROPDOWN'
        multiheaderEnabled={multiheaderEnabled}
        visible={listVisible}
        innerRef={this.onRefDropdown}
        onTransitionEnd={!listVisible ? this.onCloseComplete : null}
      >
        { !this.props.multiSelectEnabled && <input type='hidden' name={this.props.name} value={selectedValue} /> }
        <StyledButtonDropdown enabled={controlEnabled} listVisible={listVisible}
          onClick={this.handleDropdownClick}
          onKeyDown={this.handleKeyDown}
          innerRef={btn => { this.dropDownBtn = btn }}
          id={`ui__dropdown_${pID}`}>
          <StyledDropdownSpan className={inputVisible ? ' remove' : 'show'}>
            { this.renderDropdownLabel(this.state, this.props) }
          </StyledDropdownSpan>
          { this.props.typeAheadEnabled ? this.renderTypeaheadInput() : null }
          <StyledDropdownCaretArea enabled={controlEnabled}>
            <StyledDropdownCaret visible={listVisible}>
              { listVisible ? <Icon type='caretUp' /> : <Icon type='caretDown' style={this.state.controlEnabled ? { cursor: 'pointer' } : { cursor: 'not-allowed' }} /> }
            </StyledDropdownCaret>
          </StyledDropdownCaretArea>
        </StyledButtonDropdown>
        { listVisible && !multiheaderEnabled && options && options.length ? this.renderOptions(options, selectedValue) : this.renderNoResultsMessage() }
        { listVisible && multiheaderEnabled && headers && headers.length ? this.renderOptions(headers, selectedValue) : this.renderNoResultsMessage() }
      </StyledDropdownContainer>)

    return (
      <StyledOuter data-name='OUTER' useBreakout={useBreakout}>
        { this.props.primaryLabel && <StyledPrimaryLabel>{ this.props.primaryLabel }</StyledPrimaryLabel> }
        { this.props.secondaryLabel && <StyledSecondaryLabel>{ this.props.secondaryLabel }</StyledSecondaryLabel> }
        { this.props.multiSelectEnabled && this.renderMultiSelectTags() }

        <StyledWrapper data-name='WRAPPER' innerRef={this.onRefWrapper} useBreakout={useBreakout}>
          {
            isBreakoutActive
              ? <Breakout trackElement={this.wrapperEl}>{ styledDropdownContainer }</Breakout>
              : styledDropdownContainer
          }
        </StyledWrapper>
      </StyledOuter>
    )
  }

  getLabelMarkup = (item) => {
    const userInput = this.state.inputValue.toLowerCase()

    // in typeahead and multi select modes highlight parts of the values matching user input
    if (this.props.typeAheadEnabled && userInput) {
      const startOfUserInput = item.label.toLowerCase().indexOf(userInput)
      const startOfPostText = startOfUserInput + userInput.length
      const labelArray = item.label.split('')

      // IE doesn't obey pointer-events:none in option child nodes here, so in the click handler 
      // e.target can be one of the spans, hence they need the data-value attribute
      const dataAttributes = { 'data-value' : item.value }
      
      return (
        <span {...dataAttributes}>
          {labelArray.slice(0, startOfUserInput).join('')}
          <span {...dataAttributes} className='user__input-highlight'>
            {labelArray.slice(startOfUserInput, startOfUserInput + userInput.length).join('')}
          </span>
          {labelArray.slice(startOfPostText).join('')}
        </span>
      )
    } else {
      return item.label // in simple dropdown mode return text as it is
    }
  }

  checkIfOptionIsAlreadySelected = (value) => {
    if (this.props.multiSelectEnabled) {
      return (this.state.multiSelectValues.indexOf(value) > -1)
    } else {
      return false
    }
  }

  renderOptions = (inputArray, selectedValue) => {
    const count = inputArray.length
    let tabArray = 0
    
    if (this.props.multiheaderEnabled) { 
      return (
        <StyledOptionsOuter>
          <StyledOptionsList
            role='menu'
            id={`ui__dropdown_options_list_${pID}`}
            onClick={this.handleOptionClick}
            onKeyDown={this.handleOptionKeyDown}
            tabIndex='-1'>

            {inputArray.map((header, index) =>
              <StyledOptionDivWrapper key={`groupHeader_${index}_${pID}`}>
                {index === 0 &&
                  <StyledOption headerType={'dropdownLabel'}
                    key={`option_noDate_${pID}`}
                    selected={false}
                    role='menuitem'
                    data-value={this.props.placeholderText}
                    id={`ui__dropdown_option_${tabArray}_${pID}`}
                    tabIndex={tabArray++}
                    onMouseOver={this.handleOptionMouseOver}
                    alreadySelected={this.checkIfOptionIsAlreadySelected(this.props.placeholderText)}
                  >
                    {this.props.placeholderText}
                  </StyledOption>
                }
                <StyledOption headerType={'dropdownHeader'}
                  key={`header_${index}_${pID}`}
                  role='header'
                  id={`ui__dropdown_header_${tabArray}_${pID}`}
                  tabIndex={tabArray++}
                >
                  { header.label }
                </StyledOption>
                {header.options.map((option, optindex) =>
                  <StyledOption headerType={'dropdownOptions'}
                    key={`option_${optindex}_${pID}`}
                    selected={option.value === selectedValue}
                    role='menuitem'
                    data-value={option.value}
                    id={`ui__dropdown_option_${tabArray}_${pID}`}
                    tabIndex={tabArray++}
                    onMouseOver={this.handleOptionMouseOver}
                    alreadySelected={this.checkIfOptionIsAlreadySelected(option.value)}
                  >
                    { this.getLabelMarkup(option) }
                  </StyledOption>
                )}
              </StyledOptionDivWrapper>
            )}
          </StyledOptionsList>
        </StyledOptionsOuter>
      )
    }
    return (
      <StyledOptionsOuter>
        <StyledOptionsList
          role='menu'
          onClick={this.handleOptionClick}
          onKeyDown={this.handleOptionKeyDown}
          id={`ui__dropdown_options_list_${pID}`}
          tabIndex='-1'>

          {inputArray.map((item, index) =>
            <StyledOption key={`option_${index}_${pID}`}
              selected={item.value === selectedValue}
              isLastChild={index === (count - 1)}
              role='menuitem'
              data-value={item.value}
              title={item.value}
              tabIndex={index}
              onMouseOver={this.handleOptionMouseOver}
              id={`ui__dropdown_option_${index}_${pID}`}
              alreadySelected={this.checkIfOptionIsAlreadySelected(item.value)}
            >
              { this.getLabelMarkup(item) }
            </StyledOption>
          )}
        </StyledOptionsList>
      </StyledOptionsOuter>
    )
  }

  // Get a label that corresponds to a particular option value
  getLabelByValue = (selectedValue) => {
    const { placeholderText, multiheaderEnabled, headers } = this.props
    const { options } = this.state
    let label = placeholderText || 'Select a value'
    let matchingOptions = []

    if (!multiheaderEnabled && selectedValue && options && options.length) {
      matchingOptions = options.filter(item => item.value === selectedValue)
      if (matchingOptions.length) {
        label = matchingOptions[0].label
      }
    } else if (multiheaderEnabled && selectedValue && headers && headers.length) {
      headers.map((header) => {
        header.options.map((option) => {
          if (option.value === selectedValue) label = option.label
        })
      })
    }

    return label
  }

  getLabelText = () => {
    let labelText = ''
    const { multiSelectEnabled, listOpenPlaceholderText, placeholderText } = this.props
    const { listVisible, selectedValue } = this.state

    if (multiSelectEnabled) {
      labelText = listVisible ? listOpenPlaceholderText : placeholderText
    } else {
      labelText = this.getLabelByValue(selectedValue)
    }

    return labelText
  }

  renderDropdownLabel = (state, props) => {
    const { inputValue, selectedValue, listVisible, status } = state
    let labelText = this.getLabelText()

    labelText += this.props.multiheaderEnabled ? '' : inputValue

    const hasLabelTextChanged = (this.labelText !== labelText)
    const fade = (status !== CLOSED) && hasLabelTextChanged
    const key = fade ? `sdv${Math.random()}` : 'sdv0'
    const isSearchPlaceholder = (labelText === props.listOpenPlaceholderText)
    const isDefaultLabel = (labelText === props.placeholderText)
    
    this.labelText = labelText

    return (
      <StyledDropdownValue fade={fade} key={key}>
        <StyledDropdownLabel isDefaultLabel={isDefaultLabel} isSearchPlaceholder={isSearchPlaceholder} placeholder={listVisible ? 1 : 0} selected={Boolean(selectedValue)} visible={!inputValue}>
          { labelText }
        </StyledDropdownLabel>
      </StyledDropdownValue>
    )
  }

}

ComponentTypeahead.propTypes = {
  options: PropTypes.array,
  selectedValues: PropTypes.array,
  name: PropTypes.string.isRequired,
  selectedValue: PropTypes.string,
  onChange: PropTypes.func,
  placeholderText: PropTypes.string,
  noResultsFoundText: PropTypes.string,
  typeAheadEnabled: PropTypes.bool
}

export default withTheme(ComponentTypeahead)
